import { useDeleteUserMutation } from "@sso/apis/users";
import { useGetUserById } from "@sso/apis/users/hooks";
import { DialogTitle } from "@sso/constant";
import { useAppSelector } from "@sso/hooks/useRedux";
import { selectDialog } from "@sso/store/slices/dialog";
import { Typography } from "@sso/ui/Typography";

import { DialogActionButtons, DialogBody, DialogHeader } from "../components";

export const DeleteUserDialog = () => {
  const { id } = useAppSelector(selectDialog);
  const user = useGetUserById(id as string);

  const [deleteUser, { isLoading }] = useDeleteUserMutation();

  const handleDeleteAction = () => {
    if (!id || !user) {
      return;
    }
    deleteUser(id as string);
  };

  return (
    <>
      <DialogHeader title={DialogTitle.DELETE_USER} />
      <DialogBody>
        <Typography display="initial">
          Are you sure to delete this User?
          <br />
          <br />
          <small>{user ? `Name: ${user.fullName}` : "Error finding the user"}</small>
        </Typography>
      </DialogBody>
      <DialogActionButtons loading={isLoading} buttonTitle={"Delete"} onClickAction={handleDeleteAction} />
    </>
  );
};
